/*
    SUMMARY
        0 - Const / Variables
        1 - Functions
        2 - Event Listeners
        3 - Initialize
*/

/*---------------------/ 0 - Const - Variables /-------------------*/
let produtosSwiper = null;

/*---------------------/ 1 - Functions /-------------------*/

// Initialize News Page
function initNewsPage() {
    initNewsFilters();
    initNewsAnimations();
    initNewsCardInteractions();
    initProdutosSwiper();
}

// Initialize News Filters
function initNewsFilters() {
    const filterButtons = document.querySelectorAll('.noticias-section__filter');

    filterButtons.forEach(button => {
        button.addEventListener('click', function() {
            // Remove active class from all buttons
            filterButtons.forEach(btn => btn.classList.remove('noticias-section__filter--active'));

            // Add active class to clicked button
            this.classList.add('noticias-section__filter--active');

            // Get filter value
            const filterValue = this.getAttribute('data-filter');

            // Filter news items
            filterNewsItems(filterValue);
        });
    });
}

// Filter News Items
function filterNewsItems(filterValue) {
    const newsCards = document.querySelectorAll('.noticias-card');
    const mainNews = document.querySelector('.noticias-main');
    const noPostsMessage = document.querySelector('.noticias-section__no-posts');
    const newsGrid = document.querySelector('.noticias-section__news-grid');
    const mainNewsContainer = document.querySelector('.noticias-section__main-news');

    // Add loading state
    addLoadingState();

    // Make AJAX request
    fetch(`/blog/filter/${filterValue}`)
        .then(response => response.json())
        .then(data => {
            // Update main news
            if (data.latestPost) {
                mainNewsContainer.innerHTML = `
                    <article class="noticias-main">
                        <div class="noticias-main__image">
                            <img src="/userfiles/blog/posts/${JSON.parse(data.latestPost.thumb_image).src}" alt="${data.latestPost.title}">
                        </div>
                        <div class="noticias-main__content">
                            <div class="noticias-main__meta">
                                <span class="noticias-main__category">${data.latestPost.category ? data.latestPost.category.title : 'Notícia'}</span>
                                <span class="noticias-main__date">${formatDate(data.latestPost.date)}</span>
                            </div>
                            <h3 class="noticias-main__title">
                                <a href="/noticia-detalhe/${data.latestPost.slug}">${data.latestPost.title}</a>
                            </h3>
                            <p class="noticias-main__excerpt">
                                ${data.latestPost.short_description}
                            </p>
                            <a href="/noticia-detalhe/${data.latestPost.slug}" class="noticias-main__link">Ler notícia</a>
                        </div>
                    </article>
                `;
            } else {
                mainNewsContainer.innerHTML = '';
            }

            // Update grid
            const postsArray = Object.values(data.posts);
            if (postsArray.length > 0) {
            let gridHTML = '';
            postsArray.forEach(post => {
                const thumb = JSON.parse(post.thumb_image);
                gridHTML += `
                    <article class="noticias-card" data-filter="${post.id_filter}">
                        <div class="noticias-card__image">
                            <img src="/userfiles/blog/posts/${thumb.src}" alt="${thumb.alt || post.title}" class="noticias-card__img">
                        </div>
                        <div class="noticias-card__content">
                            <div class="noticias-card__meta">
                                <span class="noticias-card__date">${formatDate(post.date)}</span>
                                <span class="noticias-card__author">${post.author ? post.author.name : 'Equipe'}</span>
                            </div>
                            <h3 class="noticias-card__title">
                                <a href="/noticia-detalhe/${post.slug}">${post.title}</a>
                            </h3>
                            <p class="noticias-card__excerpt">
                                ${post.short_description}
                            </p>
                            <a href="/noticia-detalhe/${post.slug}" class="noticias-card__link">Ler mais</a>
                        </div>
                    </article>
                `;
            });
            newsGrid.innerHTML = gridHTML;
        } else {
            newsGrid.innerHTML = '<div class="noticias-section__no-posts"><p>Nenhuma notícia disponível no momento</p></div>';
        }

            // Reinitialize animations
            initNewsAnimations();
            initNewsCardInteractions();
        })
        .catch(error => {
            console.error('Error fetching filtered posts:', error);
            removeLoadingState();
        });
}

// Format date helper
function formatDate(dateString) {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = String(date.getFullYear()).slice(-2);
    return `${day}.${month}.${year}`;
}

// Initialize News Animations
function initNewsAnimations() {
    const observerOptions = {
        threshold: 0.1,
        rootMargin: '0px 0px -50px 0px'
    };

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add('animate-in');
            }
        });
    }, observerOptions);

    // Observe news cards and main news
    const newsCards = document.querySelectorAll('.noticias-card');
    const mainNews = document.querySelector('.noticias-main');
    const header = document.querySelector('.noticias-section__header');

    newsCards.forEach(card => observer.observe(card));
    if (mainNews) observer.observe(mainNews);
    if (header) observer.observe(header);
}

// Initialize News Card Interactions
function initNewsCardInteractions() {
    const newsCards = document.querySelectorAll('.noticias-card, .noticias-main');

    newsCards.forEach(card => {
        // Add hover transform effect
        card.addEventListener('mouseenter', function() {
            this.style.transform = 'translateY(-4px)';
        });

        card.addEventListener('mouseleave', function() {
            this.style.transform = 'translateY(0)';
        });

        // Add click tracking (you can implement actual navigation here)
        card.addEventListener('click', function(e) {
            if (!e.target.closest('a')) {
                // Track card click if not clicking on a link
                console.log('News card clicked');
            }
        });
    });

    // Handle image loading
    const images = document.querySelectorAll('.noticias-card__img, .noticias-main__image img');
    images.forEach(img => handleImageLoad(img));
}

// Handle Image Load
function handleImageLoad(img) {
    img.addEventListener('load', function() {
        this.style.opacity = '1';
    });

    img.addEventListener('error', function() {
        this.src = '/site/img/imagens/error.jpg'; // Fallback image
        this.style.opacity = '1';
    });
}

// Smooth scroll for anchor links
function initSmoothScroll() {
    const anchorLinks = document.querySelectorAll('a[href^="#"]');

    anchorLinks.forEach(link => {
        link.addEventListener('click', function(e) {
            e.preventDefault();
            const targetId = this.getAttribute('href');
            const targetElement = document.querySelector(targetId);

            if (targetElement) {
                targetElement.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                });
            }
        });
    });
}

// Add loading state
function addLoadingState() {
    const newsGrid = document.querySelector('.noticias-section__news-grid');
    if (newsGrid) {
        // Add placeholder loading cards
        for (let i = 0; i < 6; i++) {
            const loadingCard = document.createElement('article');
            loadingCard.className = 'noticias-card noticias-card--loading';
            loadingCard.innerHTML = `
                <div class="noticias-card__image">
                    <div class="loading-skeleton"></div>
                </div>
                <div class="noticias-card__content">
                    <div class="noticias-card__meta">
                        <div class="loading-skeleton" style="width: 60px; height: 12px;"></div>
                        <div class="loading-skeleton" style="width: 80px; height: 12px;"></div>
                    </div>
                    <div class="loading-skeleton" style="width: 100%; height: 18px; margin-bottom: 8px;"></div>
                    <div class="loading-skeleton" style="width: 80%; height: 14px;"></div>
                </div>
            `;
            newsGrid.appendChild(loadingCard);
        }
    }
}

// Remove loading state
function removeLoadingState() {
    const loadingCards = document.querySelectorAll('.noticias-card--loading');
    loadingCards.forEach(card => card.remove());
}

// Initialize Produtos Swiper
function initProdutosSwiper() {
    if (document.querySelector('.produtos-swiper')) {
        produtosSwiper = new Swiper('.produtos-swiper', {
            // Basic Options
            loop: true,
            speed: 800,
            slidesPerView: 'auto',
            spaceBetween: 20,

            // Responsive breakpoints
            breakpoints: {
                // When window width is >= 768px
                768: {
                    spaceBetween: 20,
                },
                // When window width is >= 1024px
                1024: {
                    spaceBetween: 20,
                },
                // When window width is >= 1280px
                1280: {
                    spaceBetween: 20,
                }
            },

            // Navigation arrows
            navigation: {
                nextEl: '.produtos-nav-next',
                prevEl: '.produtos-nav-prev',
            },

            // Keyboard Control
            keyboard: {
                enabled: true,
                onlyInViewport: true,
            },

            // Accessibility
            a11y: {
                enabled: true,
                prevSlideMessage: 'Produto anterior',
                nextSlideMessage: 'Próximo produto',
            },

            // Callbacks
            on: {
                init: function () {
                    // Initial setup
                    this.update();
                },
                slideChange: function () {
                    // Handle slide change if needed
                }
            }
        });
    }
}

/*---------------------/ 2 - Event Listeners /-------------------*/

// DOM Content Loaded
document.addEventListener('DOMContentLoaded', function() {
    initNewsPage();
    initSmoothScroll();
});

// Window Load
window.addEventListener('load', function() {
    // Additional initialization after all resources are loaded
    if (produtosSwiper) {
        produtosSwiper.update();
    }
});

// Window Resize
window.addEventListener('resize', function() {
    if (produtosSwiper) {
        produtosSwiper.update();
    }
});

/*---------------------/ 3 - Initialize /-------------------*/

// Export for potential external use
window.NewsPage = {
    filterNewsItems,
    addLoadingState,
    removeLoadingState
};

// Export for produtos slider
window.ProdutosSlider = {
    swiper: produtosSwiper,
    init: initProdutosSwiper,
    destroy: function() {
        if (produtosSwiper) {
            produtosSwiper.destroy(true, true);
            produtosSwiper = null;
        }
    }
};
